/**
 * CFPS Request Quote attribution — draft 2026-09-11 draft-rev2
 * First-touch UTMs + referrer → locked traffic_channel:
 * FACEBOOK | INSTAGRAM | GOOGLE | SHOPIFY | DIRECT
 * Prefills JotForm 40138529555155 hidden fields via query params.
 */
(function () {
  var COOKIE = 'cfps_ft_attr';
  var DAYS = 90;
  var FORM_ID = '40138529555155';
  var FORM_BASE = 'https://form.jotform.com/' + FORM_ID;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setCookie(name, value, days) {
    var maxAge = Math.max(1, Math.floor(days * 86400));
    document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax';
  }

  function parseUtms(search) {
    var p = new URLSearchParams(search || window.location.search || '');
    function g(k) { return (p.get(k) || '').trim(); }
    return {
      utm_source: g('utm_source'),
      utm_medium: g('utm_medium'),
      utm_campaign: g('utm_campaign')
    };
  }

  function clickIds(search) {
    var s = (search || window.location.search || '').toLowerCase();
    return {
      fb: /[?&]fbclid=/.test(s),
      ig: /[?&]igshid=/.test(s) || /[?&]igsh=/.test(s),
      google: /[?&]gclid=/.test(s) || /[?&]gbraid=/.test(s) || /[?&]wbraid=/.test(s)
    };
  }

  function hostOf(ref) {
    if (!ref) return '';
    try { return new URL(ref).hostname.replace(/^www\./i, '').toLowerCase(); }
    catch (e) { return ''; }
  }

  /** Locked coarse channels only. */
  function mapChannel(utms, referrer, search) {
    var src = (utms.utm_source || '').toLowerCase();
    var med = (utms.utm_medium || '').toLowerCase();
    var ids = clickIds(search);
    var h = hostOf(referrer);

    if (ids.fb || src === 'facebook' || src === 'fb' || src === 'fbads' || src === 'meta' ||
        src === 'metaads' || src.indexOf('facebook') !== -1) {
      return 'FACEBOOK';
    }
    if (ids.ig || src === 'instagram' || src === 'ig' || src === 'igads' ||
        src.indexOf('instagram') !== -1) {
      return 'INSTAGRAM';
    }
    if (ids.google || src === 'google' || src === 'googleads' || src === 'adwords' ||
        src === 'youtube' || src === 'google_ads' || src.indexOf('google') !== -1 ||
        src.indexOf('youtube') !== -1 || med === 'cpc' || med === 'ppc' ||
        med === 'sem' || med === 'paidsearch') {
      return 'GOOGLE';
    }
    if (src === 'shopify' || src === 'shop_app' || src === 'shopapp' ||
        src.indexOf('shopify') !== -1) {
      return 'SHOPIFY';
    }

    if (h) {
      if (h === 'facebook.com' || h === 'fb.com' || h === 'fb.me' ||
          h.slice(-13) === '.facebook.com' || h.slice(-7) === '.fb.com') {
        return 'FACEBOOK';
      }
      if (h === 'instagram.com' || h.slice(-14) === '.instagram.com') return 'INSTAGRAM';
      if (h === 'youtube.com' || h === 'youtu.be' || /google\./.test(h) ||
          h.slice(-19) === '.googleusercontent.com' || h === 'doubleclick.net' ||
          h.slice(-15) === '.doubleclick.net' || h === 'googlesyndication.com') {
        return 'GOOGLE';
      }
      if (h === 'shopify.com' || h.slice(-12) === '.shopify.com' || h === 'shop.app') {
        return 'SHOPIFY';
      }
      if (h.indexOf('centralfloridapowersports') !== -1 || h === 'cfps.myshopify.com') {
        return 'DIRECT';
      }
    }

    return 'DIRECT';
  }

  function readFirstTouch() {
    var raw = getCookie(COOKIE);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function captureFirstTouch() {
    var existing = readFirstTouch();
    if (existing && existing.traffic_channel) return existing;

    var utms = parseUtms(window.location.search);
    var channel = mapChannel(utms, document.referrer || '', window.location.search);
    var payload = {
      utm_source: utms.utm_source || '',
      utm_medium: utms.utm_medium || '',
      utm_campaign: utms.utm_campaign || '',
      traffic_channel: channel,
      referrer: document.referrer || '',
      landing: window.location.pathname + window.location.search,
      ts: Date.now()
    };
    setCookie(COOKIE, JSON.stringify(payload), DAYS);
    return payload;
  }

  function getAttribution() {
    var ft = captureFirstTouch();
    var cur = parseUtms(window.location.search);
    return {
      utm_source: cur.utm_source || ft.utm_source || '',
      utm_medium: cur.utm_medium || ft.utm_medium || '',
      utm_campaign: cur.utm_campaign || ft.utm_campaign || '',
      traffic_channel: ft.traffic_channel || mapChannel(cur, document.referrer || '', window.location.search)
    };
  }

  function applyAttrToUrl(urlString) {
    var attr = getAttribution();
    var u;
    try { u = new URL(urlString, window.location.href); }
    catch (e) { return urlString; }
    if (u.hostname.indexOf('jotform') !== -1 && String(u.pathname).indexOf(FORM_ID) !== -1) {
      u.protocol = 'https:';
      u.hostname = 'form.jotform.com';
      if (u.pathname.indexOf('/form/') === 0) u.pathname = '/' + FORM_ID;
    }
    ['utm_source', 'utm_medium', 'utm_campaign', 'traffic_channel'].forEach(function (k) {
      if (attr[k]) u.searchParams.set(k, attr[k]);
    });
    return u.toString();
  }

  window.cfpsRqOpen = function (pleaseSend) {
    var u = new URL(FORM_BASE);
    if (pleaseSend) u.searchParams.set('pleaseSend', pleaseSend);
    var attr = getAttribution();
    ['utm_source', 'utm_medium', 'utm_campaign', 'traffic_channel'].forEach(function (k) {
      if (attr[k]) u.searchParams.set(k, attr[k]);
    });
    window.open(u.toString(), 'blank', 'scrollbars=yes,toolbar=no,width=700,height=500');
    return false;
  };

  window.cfpsRqGetAttribution = getAttribution;

  function enhanceDom() {
    captureFirstTouch();

    document.querySelectorAll('a[href*="' + FORM_ID + '"]').forEach(function (a) {
      a.setAttribute('href', applyAttrToUrl(a.getAttribute('href')));
    });

    document.querySelectorAll('iframe[src*="' + FORM_ID + '"]').forEach(function (frame) {
      frame.setAttribute('src', applyAttrToUrl(frame.getAttribute('src')));
    });

    document.querySelectorAll('form[action*="' + FORM_ID + '"]').forEach(function (form) {
      if (form.getAttribute('data-cfps-rq-bound') === '1') return;
      form.setAttribute('data-cfps-rq-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var action = form.getAttribute('action') || '';
        var m = action.match(/pleaseSend=([^'"&\s]+)/);
        var pleaseSend = m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : (document.title || '');
        window.cfpsRqOpen(pleaseSend);
        return false;
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceDom);
  } else {
    enhanceDom();
  }
})();
